export default {
  ticketTitle: 'TICKET_TITLE',
  ticketMembers: 'TICKET_MEMBERS',
  ticketMemberChannel: 'TICKET_MEMBER_CHANNEL',
  ticketAdditionalActions: 'TICKET_ADDITIONAL_ACTIONS',
  ticketReopen: 'TICKET_REOPEN_TICKET',
  ticketDuplicate: 'TICKET_DUPLICATE_TICKET',
  ticketUpdate: 'TICKET_UPDATE_TICKET',
  ticketSendButton: 'TICKET_SEND_BUTTON',
  ticketOriginOfTheDeclaration: 'TICKET_ORIGIN_OF_THE_DECLARATION',
  ticketDeclarer: 'TICKET_DECLARER',
  ticketCollective: 'TICKET_COLLECTIVE',
  ticketIndividual: 'TICKET_INDIVIDUAL',
  ticketName: 'TICKET_NAME',
  ticketTypeOfProblem: 'TICKET_TYPE_OF_PROBLEM',
  ticketImmeuble: 'TICKET_IMMEUBLE',
  ticketAppartement: 'TICKET_APARTEMENT',
  ticketZone: 'TICKET_ZONE',
  ticketEquipments: 'TICKET_EQUIPMENTS',
  ticketZones: 'TICKET_ZONES',
  ticketNatureOfTheProblem: 'TICKET_NATURE_OF_THE_PROBLEM',
  ticketEquipment: 'TICKET_EQUIPMENT',
  ticketDescriptionOfTheProblem: 'TICKET_DESCRIPTION_OF_THE_PROBLEM',
  ticketAttachDocuments: 'TICKET_ATTACH_DOCUMENTS',
  ticketAddASpeaker: 'TICKET_ADD_SPEAKER',
  ticketManager: 'TICKET_MANAGER',
  ticketManagerAssign: 'TICKET_MANAGER_ASSIGN',
  ticketNotifyTheOwner: 'TICKET_NOTIFY_THE_OWNER',
  ticketConcierge: 'TICKET_CONCIERGE',
  ticketFlatmate: 'TICKET_FLATMATE',
  ticketResidentOfTheBuilding: 'TICKET_RESIDENT_OF_THE_BUILDING',
  ticketPlumbing: 'TICKET_PLUMBING',
  ticketCreateNew: 'TICKET_CREATE_NEW',
  ticketSave: 'TICKET_SAVE',
  ticketCreateOther: 'TICKET_CREATE_ANOTHER_TICKET',
  ticketCreator: 'TICKET_CREATOR',
  ticketAssigned: 'TICKET_ASSIGNED',
  ticketAssignedMore: 'TICKET_ASSIGNED_MORE',
  ticketprivate: 'TICKET_PRIVATE',
  ticketpublic: 'TICKET_PUBLIC',
  ticketinternal: 'TICKET_INTERNAL',
  ticketIndependentContractorMandate: 'TICKET_INDEPENDENT_CONTRACTOR_MANDATE',
  ticketMantenanceDate: 'TICKET_MANTENANCE_DATE',
  ticketState: 'TICKET_STATE',
  ticketLastAction: 'TICKET_LAST_ACTION',
  ticketCharacterProblem1: 'TICKET_CHARACTER_PROBLEM_PLUMBING',
  ticketCharacterProblem2: 'TICKET_CHARACTER_PROBLEM_ELECTRICITY',
  ticketCharacterProblem3: 'TICKET_CHARACTER_PROBLEM_HOME_APPLIANCE',
  ticketCharacterProblem4: 'TICKET_CHARACTER_PROBLEM_HEATING',
  ticketCharacterProblem5: 'TICKET_CHARACTER_PROBLEM_GLAZIERY',
  ticketCharacterProblem6: 'TICKET_CHARACTER_PROBLEM_OTHER',
  ticketTypeOfProblems: {
    public: 'TICKET_TYPE_OF_PROBLEMS_COLLECTIVE',
    private: 'TICKET_TYPE_OF_PROBLEMS_INDIVIDUAL',
    internal: 'TICKET_TYPE_OF_PROBLEMS_INTERNAL'
  },
  ticketAssginedManager: 'TICKET_ASSIGNED_MANAGER',
  ticketSortBy: 'TICKET_SORTBY',
  ticketChatActionsAskAppointment: 'TICKET_CHAT_ACTION_ASK_APPOINTMENT',
  ticketChatActionsAddAppointment: {
    tenant: 'TICKET_CHAT_ACTION_ASK_APPOINTMENT',
    owner: 'TICKET_CHAT_ACTION_ASK_APPOINTMENT',
    salesperson: 'TICKET_CHAT_ACTION_ASK_APPOINTMENT',
    independent_contractor: 'TICKET_CHAT_ACTION_ASK_APPOINTMENT_IC',
    manager: 'TICKET_CHAT_ACTION_ADD_APPOINTMENT',
    caretaker: 'TICKET_CHAT_ACTION_ADD_APPOINTMENT',
    admin: 'TICKET_CHAT_ACTION_ADD_APPOINTMENT',
    maintenance_referent: 'TICKET_CHAT_ACTION_ADD_APPOINTMENT',
    external_provider: 'TICKET_CHAT_ACTION_ASK_APPOINTMENT_IC',
    simple_user: 'TICKET_CHAT_ACTION_ASK_APPOINTMENT',
    vehicle_referent: 'TICKET_CHAT_ACTION_ADD_APPOINTMENT'
  },
  ticketChatActionsAskQuote: 'TICKET_CHAT_ACTION_ASK_QUOTE',
  ticketChatActionsAskQuoteLabel: 'TICKET_CHAT_ACTION_ASK_QUOTE_LABLE',
  ticketChatActionsAnnotation: 'TICKET_CHAT_ACTION_ANNOTATION',
  ticketChatActionsAttachFile: 'TICKET_CHAT_ACTION_ATTACHFILE',
  ticketChatActionsAttactDocument: 'TICKET_CHAT_ACTION_ATTACHDOCUMENT',
  ticketChatActionsMandateASpecker: 'TICKET_CHAT_ACTION_MANDATE_SPREAKER',
  ticketChatActionsClose: 'TICKET_CHAT_ACTION_CLOSE',
  ticketChatActionsGenerateInterventionReport: 'TICKET_CHAT_ACTION_GENERATE_INTERVENTION_REPORT',
  ticketAssignMe: 'TICKET_ASSIGN_ME',
  ticketCreate: 'TICKET_CREATE',
  ticketEdit: 'TICKET_UPDATE',
  ticketMandateContractor: 'TICKET_MANDATE_CONTRACTOR',
  ticketMandateOrderService: 'TICKET_MANDATE_ORDER_SERVICE',
  ticketMandateAttachment: 'TICKET_MANDATE_ORDER_ATTACHMENT',
  ticketInternal: 'TICKET_INTERNAL_TEXT',
  ticketGotoAgenda: 'TICKET_GOTO_AGENDA',
  ticketCreateAnotherTicket: 'TICKET_CREATE_ANOTHER_TICKET',
  ticketCloseTicket: 'TICKET_CLOSE_TICKET',
  ticketCloseTicketTitle: 'TICKET_CLOSE_TICKET_TITLE',
  ticketCloseTicketSeperator: 'TICKET_CLOSE_TICKET_SEPERATOR',
  ticketCreateGroupTitle: 'TICKET_CREATE_GROUP_TITLE',
  ticketGroup: 'TICKET_GROUP',
  ticketGroupMember: 'TICKET_GROUP_MEMBER',
  ticketNotificationTitle: 'TICKET_NOTIFICATION_TITLE',
  ticketNotificationMessage: 'TICKET_NOTIFICATION_MESSAGE',
  ticketIndependentContractors: 'TICKET_INDEPENDENT_CONTRACTOR',
  ticketCaretakers: 'TICKET_CARETAKER',
  ticketAppointmentDesc: 'TICKET_APPOINTMENT_DESCRIPTION',
  ticketRequestToJoin: 'TICKET_REQUEST_TO_JOIN',
  ticketClosureReason: 'TICKET_CLOSURE_REASON',
  ticketReason: 'TICKET_REASON',
  ticketClosureReasonDescription: 'TICKET_CLOSURE_REASON_DESCRIPTION',
  ticketClosureReasonPlacehodler: 'TICKET_CLOSURE_REASON_PLACEHOLDER',
  ticketReasonPlacehodler: 'TICKET_REASON_PLACEHOLDER',
  ticketRequestToJoinChannel: 'TICKET_REQUEST_JOIN_CHANNEL',
  ticketInviteMember: 'TICKET_INVITE_MEMBERS',
  ticketInviteModal: 'TICKET_INVITE_MODAL_TITLE',
  ticketSelectInterventionReport: 'TICKET_SELECT_AN_INTERVENTION_RERPOT',
  ticketRangeDates: 'TICKET_INTERVENTION_REPORT_RANGE_OF_DATES',
  ticketReserve: 'TICKET_INTERVENTION_REPORT_RESERVE',
  ticketSignature: 'TICKET_INTERVENTION_SIGNATURE',
  ticketIntervention: 'TICKET_INTERVENTION',
  ticketPrevious: 'TICKET_INTERVENTION_PREVIOUS',
  ticketNext: 'TICKET_INTERVENTION_NEXT',
  ticketAttachments: 'TICKET_ATTACHMENTS',
  ticketUploadedBy: 'TICKET_UPLOADED_BY',
  ticketClosureReasonConversationName: 'TICKET_CLOSURE_REASON_CONVERSATION_NAME',
  ticketReasonConversationName: 'TICKET_REASON_CONVERSATION_NAME',
  ticketClosureReasonConversationDesc: 'TICKET_CLOSURE_REASON_CONVERSATION_DESC',
  ticketVisibility: 'TICKET_VISIBILITY',
  ticketVisibilitySelf: 'TICKET_VISIBILITY_SELF',
  ticketVisibilityPark: 'TICKET_VISIBILITY_PARK',
  ticketVisibilityAgency: 'TICKET_VISIBILITY_AGENCY',
  ticketFailedMessage: 'TICKET_FAILED_MESSAGE',
  ticketRetryButton: 'TICKET_RETRY_BUTTON',
  ticketMessageUpdated: 'TICKET_MESSAGE_UPDATED',
  ticketMessageDelete: 'TICKET_MESSAGE_DELETE',
  ticketAttachmentDelete: 'TICKET_ATTACHMENT_DELETE',
  ticketParticipants: 'TICKET_PARTICIPANTS',
  ticketCopyOf: 'TICKET_COPY_OF',
  ticketOneMoreValue: 'TICKET_ONE_MORE_VALUE',
  ticketOthersValue: 'TICKET_OTHERS_VALUE',
  ticketAppartmentHorsImmeuble: 'TICKET_APPARTMENT_HORS_IMMEUBLE',
  ticketInterventionNumberKm: 'TICKET_INTERVENTION_NUMBER_KM',
  ticketDescription: 'TICKET_DESCRIPTION',
  ticketPriorityLevel: 'TICKET_PRIORITY_LEVEL',
  ticketSubstatus: 'TICKET_SUBSTATUS',
  ticketVehicleMileage: 'TICKET_VEHICLE_MILEAGE',
  ticketVehicleAvailability: 'TICKET_VEHICLE_AVAILIBILITY',
  ticketShowAllContractor: 'TICKET_SHOW_ALL_CONTRACTOR',
  ticketImportDocFromGED: 'TICKET_IMPORT_DOC_FROM_GED'
}



// WEBPACK FOOTER //
// ./src/locales/ticket/index.ts